module.exports = {
  background: '#BBBBBB',
  backgroundDark: '#f0e6f6',

  primary: '#000000',
  primaryLight: '#444444',
  primaryDark: '#777777',

  secondary: '#FFFFFF',
  secondaryLight: '#BBBBBB',
  secondaryDark: '#999999',

  black: '#000000',
  white: '#FFFFFF',
  gray: '#808080',
  grayDark: '#333333',
  grayLight: '#CCCCCC',
  grayVeryLight: '#EEEEEE',
};
